import { render, staticRenderFns } from "./VehiclesModuleLayout.vue?vue&type=template&id=dbdcfc20"
import script from "./VehiclesModuleLayout.vue?vue&type=script&lang=js"
export * from "./VehiclesModuleLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports